export default __webpack_public_path__ + "5a476e62b67a886e99ccc3ad9740aa3e.png";